// import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import { getTemplesDetails } from "../Services/user.service";
// // import { getTemplesDetails } from "../Services/auth.service";
// import {
//   IonPage,
//   IonContent,
//   IonCard,
//   IonLoading,
//   IonGrid,
//   IonRow,
//   IonCol,
//   IonText
// } from "@ionic/react";
// import HeadFoot from "./Head";
// import Breadcrumb from "../components/Breadcrumb";
// import CommonModal from "../components/popipInfo";
// import Foot from "./Foot";
 
// interface Temple {
//   location: string;
//   count: number;
//   templeCode: string;
//   templeName: string;
//   mainDeity: string;
// }
 
// const TemplesClickedNew: React.FC = () => {
//   const history = useHistory();
 
//   const usertoken = sessionStorage.getItem("token");
//   const userId = sessionStorage.getItem("UserId");
 
//   const [temples, setTemples] = useState<Temple[]>([]);
//   const [showLoading, setShowLoading] = useState(false);
//   const [index, setIndex] = useState(0);
 
//   const [Commonmodal, setCommonmodal] = useState(false);
//   const [CommonModalMesg, setCommonModalMesg] = useState("");
//   const [Commmonmodaltitle, setCommonmodaltitle] = useState("");
 
//   useEffect(() => {
//     const fetchTemples = async () => {
//       const storedUserId = sessionStorage.getItem("UserId");
//       if (!storedUserId) {
//         console.warn("UserId is null. Redirecting to login or showing modal.");
//         return;
//       }
 
//       setShowLoading(true);
//       try {
//         const response = await getTemplesDetails(usertoken as string, storedUserId);
//         console.log("getTemplesDetails response:", response);
 
//         if (response && Array.isArray(response.data)) {
//           setTemples(response.data);
//         } else {
//           setTemples([]);
//         }
//       } catch (error) {
//         console.error("Error fetching temples:", error);
//         setTemples([]);
//       } finally {
//         setShowLoading(false);
//       }
//     };
 
//     fetchTemples();
//   }, []);
 
 
//   //  useEffect(() => {
//   //   const fetchTemples = async () => {
//   //     const storedUserId = sessionStorage.getItem("UserId");
//   //     if (!storedUserId) {
//   //       console.warn("UserId is null. Redirecting to login or showing modal.");
//   //       return;
//   //     }
 
//   //     setShowLoading(true);
//   //     try {
//   //       const response = await getTemplesDetails1(usertoken as string, storedUserId);
//   //       console.log("getTemplesDetails1 response:", response);
 
//   //       if (response && Array.isArray(response.data)) {
//   //         setTemples(response.data);
//   //       } else {
//   //         setTemples([]);
//   //       }
//   //     } catch (error) {
//   //       console.error("Error fetching temples:", error);
//   //       setTemples([]);
//   //     } finally {
//   //       setShowLoading(false);
//   //     }
//   //   };
 
//   //   fetchTemples();
//   // }, []);
 
//   const modalClose = () => {
//     if (!userId) {
//       history.push("/login");
//     } else {
//       setCommonmodal(false);
//     }
//   };
 
//   const pageNames = ["Temples Clicked New"];
 
//   return (
//     <IonPage>
//       <HeadFoot User={"login"} Role="Role" Name={"Home,Temples Clicked"} />
//       <IonContent>
 
//         <IonLoading message="Loading..." isOpen={showLoading} />
//         <Breadcrumb pageNames={pageNames} currentPage={index} />
//         <div className="temple-grid flex flex-wrap justify-center">
 
//           <IonGrid>
//             <IonRow>
 
//               {temples.length > 0 ? (
//                 temples.map((temple) => (
//                   <IonCol size="12" sizeMd="6" sizeLg="4" key={temple.templeCode}>
//                     <IonCard className="temple-card">
//                       <div className="temple-content">
//                         {/* <p className="temple-title">{temple.templeCode}</p>
//                         <h3 className="temple-title">{temple.templeName}</h3> */}
//                         <h3 className="temple-title">
//                           {temple.templeName} [{temple.templeCode}]
//                         </h3>
//                         <p className="temple-details1">{temple.mainDeity}</p>
//                         <p className="temple-details2">{temple.location}</p>
//                         <p className="temple-details3">Temple Counts : {temple.count}</p>
//                       </div>
//                     </IonCard>
//                   </IonCol>
//                 ))
//               ) : (
//                 <IonCol size="12">
//                   <div className="no-data-message">
//                     <IonText>No Data Available</IonText>
//                   </div>
//                 </IonCol>
//               )}
//             </IonRow>
//           </IonGrid>
//         </div>
//       </IonContent>
//       <CommonModal
//         showModal={Commonmodal}
//         closeModal={modalClose}
//         modaltitle={Commmonmodaltitle}
//         AlertModalMesg={CommonModalMesg}
//       />
//       <Foot />
//     </IonPage>
//   );
// };
 
// export default TemplesClickedNew;
 
 
 
 
 
 import React, { useEffect, useState } from "react";
 import { useHistory } from "react-router-dom";
 import { getTemplesDetails } from "../Services/user.service";
 // import { getTemplesDetails } from "../Services/auth.service";
 import {
   IonPage,
   IonContent,
   IonCard,
   IonLoading,
   IonGrid,
   IonRow,
   IonCol,
   IonText
 } from "@ionic/react";
 import HeadFoot from "./Head";
 import Breadcrumb from "../components/Breadcrumb";
 import CommonModal from "../components/popipInfo";
 import Foot from "./Foot";
 
 interface Temple {
   location: string;
   count: number;
   templeCode: string;
   templeName: string;
   mainDeity: string;
 }
 
 const TemplesClickedNew: React.FC = () => {
   const history = useHistory();
 
   const usertoken = sessionStorage.getItem("token");
   const userId = sessionStorage.getItem("UserId");
 
   const [temples, setTemples] = useState<Temple[]>([]);
   const [showLoading, setShowLoading] = useState(false);
   const [index, setIndex] = useState(0);
 
   const [Commonmodal, setCommonmodal] = useState(false);
   const [CommonModalMesg, setCommonModalMesg] = useState("");
   const [Commmonmodaltitle, setCommonmodaltitle] = useState("");
 
   useEffect(() => {
     const fetchTemples = async () => {
       const storedUserId = sessionStorage.getItem("UserId");
       if (!storedUserId) {
         console.warn("UserId is null. Redirecting to login or showing modal.");
         return;
       }
 
       setShowLoading(true);
       try {
         const response = await getTemplesDetails(usertoken as string, storedUserId);
         console.log("getTemplesDetails response:", response);
 
         if (response && Array.isArray(response.data)) {
           setTemples(response.data);
         } else {
           setTemples([]);
         }
       } catch (error) {
         console.error("Error fetching temples:", error);
         setTemples([]);
       } finally {
         setShowLoading(false);
       }
     };
 
     fetchTemples();
   }, []);
 
 
   const modalClose = () => {
     if (!userId) {
       history.push("/login");
     } else {
       setCommonmodal(false);
     }
   };
 
   const pageNames = ["Temples Clicked New"];
 
   return (
     <IonPage>
       <HeadFoot User={"login"} Role="Role" Name={"Home,Temples Clicked"} />
       <IonContent>
 
         <IonLoading message="Loading..." isOpen={showLoading} />
         <Breadcrumb pageNames={pageNames} currentPage={index} />
         <div className="temple-grid flex flex-wrap justify-center">
 
           <IonGrid>
             <IonRow>
 
               {temples.length > 0 ? (
                 temples.map((temple) => (
                   <IonCol size="12" sizeMd="6" sizeLg="4" key={temple.templeCode}>
                     <IonCard className="temple-card">
                       <div className="temple-content">
                         <h3 className="temple-title">
                           {temple.templeName} [{temple.templeCode}]
                         </h3>
                         {/* <p className="temple-details1">{temple.mainDeity}</p> */}
                         {/* <p className="temple-details2">{temple.location}</p> */}
                         <p className="temple-details3">Temple Counts : {temple.count}</p>
                       </div>
                     </IonCard>
                   </IonCol>
                 ))
               ) : (
                 <IonCol size="12">
                   <div className="no-data-message">
                     <IonText>No Data Available</IonText>
                   </div>
                 </IonCol>
               )}
             </IonRow>
           </IonGrid>
         </div>
       </IonContent>
       <CommonModal
         showModal={Commonmodal}
         closeModal={modalClose}
         modaltitle={Commmonmodaltitle}
         AlertModalMesg={CommonModalMesg}
       />
       <Foot />
     </IonPage>
   );
 };
 
 export default TemplesClickedNew;
 
 
 
 
 